/** Shared Tailwind classes for dark auth pages (login, register). */

export const authPageClass =
  'min-h-screen flex items-center justify-center bg-[#0d0d0d] py-12 px-4 sm:px-6 lg:px-8 text-white'

export const authHeadingClass = 'text-center text-3xl font-extrabold text-white'

export const authSubtextClass = 'mt-2 text-center text-sm text-gray-400'

export const authLinkClass = 'font-medium text-white hover:text-gray-200 underline-offset-2 hover:underline'

export const authMutedLinkClass = 'text-sm text-gray-400 hover:text-white transition-colors'

export const authLabelClass = 'block text-sm font-medium text-gray-300'

export const authInputClass =
  'block w-full px-3 py-2 bg-[#1a1a1a] border border-gray-600 text-white placeholder-gray-500 focus:outline-none focus:ring-[#FF5A00] focus:border-[#FF5A00] sm:text-sm disabled:opacity-50'

export const authInputErrorClass = 'border-red-500 focus:ring-red-500 focus:border-red-500'

export const authErrorTextClass = 'mt-1 text-sm text-red-400'

export const authSubmitClass =
  'group relative w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-md bg-white text-[#0d0d0d] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0d0d0d] focus:ring-white disabled:opacity-50 disabled:cursor-not-allowed'

export const authDividerLineClass = 'w-full border-t border-gray-700'

export const authDividerLabelClass = 'px-2 bg-[#0d0d0d] text-gray-500'

export const authSectionDividerClass = 'border-t border-gray-700 pt-6'

export const authFootnoteClass = 'text-xs text-gray-500 hover:text-gray-300 hover:underline transition-colors'
